export function replaceAt(str, index, sourcement, replacement) {
  if (index >= str.length) {
    return str;
  }
  return str.substring(0, index) + replacement + str.substring(index + sourcement.length);
}

export function replaceSubstring(originalStr, pos, sourceStr, replacementStr) {
  // 获取原始字符串的长度
  const strLength = originalStr.length;

  // 检查开始位置是否有效
  if (pos < 0 || pos >= strLength) {
    console.error('开始位置无效！');
    return originalStr;
  }

  // 获取源字符串在原始字符串中的位置
  const sourceIndex = originalStr.indexOf(sourceStr, pos);

  // 如果没有找到源字符串，则不进行替换
  if (sourceIndex === -1) {
    return originalStr;
  }

  // 替换指定位置的源字符串
  return [
    originalStr.slice(0, sourceIndex),
    replacementStr,
    originalStr.slice(sourceIndex + sourceStr.length)
  ].join('');
}